<template>
    <section class="import-contact-importer d-flex flex-column gap-2">
        <section class="information d-flex flex-column gap-2">
            <span class="text-center">{{$t('com.file.import-concatc-importer.add-muliple-contact-title')}}:</span>
            <span class="text-center" style="font-weight: bold">{{$t('com.file.import-concatc-importer.add-muliple-contact-pattern-example')}}</span>
            <span class="text-center">{{$t('com.file.import-concatc-importer.example')}}:</span>
            <span class="text-center">{{$t('com.file.import-concatc-importer.example-data')}}</span>
            <span class="text-center" style="color: red">{{$t('com.global.attention')}}</span>
            <span class="text-center">{{$t('com.file.import-concatc-importer.empty-email-info')}}</span>
            <span class="text-center">{{$t('com.file.import-concatc-importer.example')}}:</span>
            <span class="text-center" style="font-weight: bold">{{$t('com.file.import-concatc-importer.example-data-empty-email')}}</span>
        </section>
        <textarea v-model="inlineData" class="inline-data" cols="5" rows="10"></textarea>
        <section class="d-flex justify-content-center">
            <ButtonBasic @click="next" color="danger" size="lg" :disabled="inlineData === ''">{{$t('com.file.import-concatc-importer.load')}}</ButtonBasic>
        </section>

    </section>
</template>
<script charset="utf-8">
    import importContactService from "../../../../../../../services/import.contact.service"

    export default {
        name: "ImportConcatcImporter",
        data() {
            return {
                inlineData: "",
            }
        },
        methods: {
            next() {
                try {
                    importContactService.parseInputData(this.inlineData);
                }
                catch (e) {
                    console.log(e);
                }

            }
        }
    }
</script>